import baseApi from "./baseApi";

const UsuariosCadastrados = async () => {
    try {
        const response = await baseApi.post('/usuarios', {})
        if(response.data){
            return response.data
        } 

            return [];

    } catch(erro){

    }
}

const CadastrarUsuario = async (email, nome, senha) => {
    try {

        const response =  await baseApi.post('/usuarios/novo', {
            email: email,
            name: nome,
            password: senha
        })

        if(response.data){
            return response.data
        }


    }catch(error){
        return error
    }
}

export default {
    UsuariosCadastrados,
    CadastrarUsuario
}